export default [
    {
        id: 'email_subject_convo_name',
        value: '{convoName}',
    },
    {
        id: 'email_subject_new_chat',
        value: 'You have a new {channelName} Chat available 💬',
    },
    {
        id: 'custom_subject_line',
        value: 'Custom Subject Line',
    },
];
